import styles from './Tabs.module.scss';

import { Tab } from '@/components/Tabs/components/Tab';
import { ROUTES_CONFIG } from '@/modules/page/routes';
import { isTelegramApp } from '@/utils';
import cn from 'classnames';

export const Tabs = () => {
  const tabs = [
    ROUTES_CONFIG.POLLS,
    ROUTES_CONFIG.TOURNAMENTS,
    ROUTES_CONFIG.UGC,
    ROUTES_CONFIG.OPINIONS,
    ROUTES_CONFIG.PROFILE_ID,
  ];

  return (
    <>
      {!isTelegramApp() && <div className={styles.appTabsSpace} />}
      <div className={cn(styles.tabs, 'app-tabs')}>
        {tabs.map((tab) => {
          return <Tab key={tab.path} tab={tab} />;
        })}
      </div>
    </>
  );
};
